import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import axios from 'axios';
import queryString from 'query-string';
import { ReferralService } from 'services';
import { InviteImage, GooglePlayButton, AppStoreButton } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Referral extends React.Component<Props> {

	state = {
		link_android: '',
		link_ios: ''
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Referidos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const params = queryString.parse(this.props.location.search);
		const res: any = await ReferralService.save({
			code: params?.code
		});
		const url_android = new URL(res.link_android);
		// @ts-ignore
		url_android.searchParams.set('referrer','referral_code=' + params?.code);
		this.setState({
			link_android: url_android,
			link_ios: res.link_ios
		});
	}

	render() {
		return (
			<div id="referral">
				<div className="container">
					<h3>¡Obtén grandes beneficios al recomendar nuestra app!</h3>
					<div className="row">
						<div className="col-md-6 text-center">
							<img src={ InviteImage } className="image-invite" />
						</div>
						<div className="col-md-6">
							<p>Te damos una <strong>recompensa para ti y tus amigos</strong> que descarguen nuestra app, es muy sencillo.</p>
							<p>Ganar puntos te permitirá <strong>subir de nivel</strong> para acceder y disfrutar de nuevos beneficios.</p>
							<div className="row">
								{
									this.state.link_android && (
										<div className="col-md-6 text-center">
											<a href={ this.state.link_android } target="_blank" className="btn-shop">
												<img src={ GooglePlayButton } />	
											</a>
										</div>
									)
								}
								{
									this.state.link_ios && (
										<div className="col-md-6 text-center">
											<a href={ this.state.link_ios } target="_blank" className="btn-shop">
												<img src={ AppStoreButton } />	
											</a>
										</div>
									)
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect()(Referral);